import dayjs from 'dayjs';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
// import ReactStars from "react-stars";
import Image from 'next/image';
import dynamic from "next/dynamic";

const ReactStars = dynamic(() => import("react-stars"), {
   ssr: false,
 });
import { cardColors, textColors } from 'src/constants/wall.constant';
import {socialCardKeys} from 'src/constants/socialcard.constant'
import ClassNames from 'src/components/componentHelper/ClassNames';

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const AppStoreCard = ({ cardItem,cardWidth, fontStyle, linkColor, cardBackgroundObject, highlightColor, darkModeEnabled=false, cardFontColor, darkCardTheme, smallSize, shortenText, refresh, isDateTimeDisabled, ratingColor}) => {

   const options = {
      replace: domNode => {
         const attribProps = attributesToProps(domNode.attribs);
  
         if (domNode.name === 'a') {
            return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
         }
         else if(domNode.name === 'b'){
            let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
            if (darkModeEnabled) {
              bStyle.color = '#726c6c';
            }
            return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
         }
      }
   }

   return(
         <div className={ClassNames(darkModeEnabled ? "border-none" : "border border-gray-200 bg-white", "relative z-0 transition-all w-full card-holder")} style={{maxWidth: "40rem",minWidth:cardWidth}}>
         <div 
         className="card social-card-style select-none relative transition-all"
         style={cardBackgroundObject? cardBackgroundObject:{}}
         >
           
           <div className={ClassNames("w-full flex padding-bottom--lg padding-bottom--lg",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')}>
               <div  style={{minWidth:'48px'}}>
                  <a href={cardItem[socialCardKeys.messageLink] || void(0)} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">
                  {
                     cardItem[socialCardKeys.authorImage]?
                  <Image priority={true}  src={cardItem[socialCardKeys.authorImage] || `https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }} />
                  :
                  <img  src={`https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }}/>
                  }
               </a>
               </div>
               <div className="flex-grow pl-3">
                  <div className="flex justify-between">
                     <div className=''>
                        <h6 className="font-bold text-md inline">
                           <a className='cursor-pointer' href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { fontWeight: 600, color: (cardFontColor || textColors.black.primary), lineHeight: 1.2, textDecoration: 'none' } : { fontWeight: 600, color: (cardFontColor || textColors.light.primary), lineHeight: 1.2, textDecoration: 'none' }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer">{cardItem[socialCardKeys.authorName]}</a>
                        </h6>
                     </div>
                     <div style={{minWidth:'35px'}}>
                        <a className='cursor-pointer' href={cardItem[socialCardKeys.messageLink] || void(0)} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">
                        <Image  src={'/appstore.svg'} loading="lazy"  AppStoreIcon width="35px" height="35px" />
                        </a>
                     </div>
                  </div>
                  { cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='' && <div className="text-sm font-roboto"><a style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), fontSize: '13.5px' } : { color: (cardFontColor || textColors.light.primary), fontSize: '13.5px' }} className={!darkModeEnabled ? 'text-gray-700' : 'text-gray-300'} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.workTitle]}</a></div> }
               </div>
            </div>
            <div className="tweet-content" style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize ? "1.15em" : "1.0em", lineHeight: !smallSize ? 1.5 : 1.7 }}>
            <div className={ClassNames("content",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')} dir="auto">
               {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent], options)
                  :
                  null
               }
               </div>

            </div>
            <div>

               <div>
               {
                             cardItem[socialCardKeys.starRating] && cardItem[socialCardKeys.starRating]>0 ? 
                             <div className="whitespace-nowrap" style={{ lineHeight: 1, paddingBottom: !smallSize ? '1.15em' : '1em' }}>
                                     <ReactStars
                                         count={5}
                                         className='flex'
                                         value={cardItem[socialCardKeys.starRating]}
                                         edit={false}
                                         size={24}
                                         color2={ratingColor?ratingColor:'#f59e0b'}
                                     />
                                 </div>
                                 :
                                 null
                          }
                  <div className={(fontStyle && fontStyle!=='')?`font-${fontStyle}`:''} style={!darkModeEnabled?{color: (cardFontColor || textColors.black.secondary), fontSize: 14}:{color: (cardFontColor || textColors.light.secondary), fontSize: 14}}>
                  <span>{(!isDateTimeDisabled && cardItem[socialCardKeys.messageTime])?dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY'):null}</span>
               </div>
               </div>

            </div>
         </div>
         </div>
      )
   }

export default AppStoreCard;

